export const OKTA_LOGIN_IN_PROGRESS_SESSION_KEY = 'gsOktaLoginInProgress';
